module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/sakae_point3_1-dcd1a741ab9867a8fcfb56c14537b453.jpg";